// When the middlegame turned: games whose reader gave up at least half a pawn
// with their own middlegame moves in a band of move numbers (`MiddlegameTurn`,
// `middlegameTurnsOf`). Like `blunder` it lives in the scan's facts
// (`stageCurves`), which the filter does not read: whoever applies the filter
// resolves it first into `ids` (the game store's `resolveFilter`).
// Unresolved, it matches no game. The Middlegame screen's "When it turns"
// columns open the library with it.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { MIDDLEGAME_TURNS, MIDDLEGAME_TURN_LABEL, type MiddlegameTurn } from '@chess/api-model';

export const middlegameTurn: FilterCriterion<'middlegameTurn'> = {
  key: 'middlegameTurn',
  query: 'middlegame-turn',
  many: true,
  parse: oneOf(MIDDLEGAME_TURNS),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 71,
    more: true,
    label: 'Middlegame score lost at moves',
    options: MIDDLEGAME_TURNS.map((t) => [t, `Moves ${MIDDLEGAME_TURN_LABEL[t]}`] as [MiddlegameTurn, string]),
  },
};
